import { CONTACT_SUPPORT_LOWERCASE_LABEL } from 'constants/labels';

const defaultAlertErrors = [`Request failed. Please ${CONTACT_SUPPORT_LOWERCASE_LABEL} for assistance.`];

export default defaultAlertErrors;
